import React, { useEffect, useState } from 'react';
import { array, string } from 'prop-types';

import { connect } from 'react-redux';

import { isEmpty  } from 'lodash';
import BobLoadingMask from '../../../components/BobLoadingMask';
import ServiceItemListItem from './ServiceItemListItem';
import { Pager } from '@progress/kendo-react-data-tools';
import { format } from '../../../utils/date-util';

import * as CoreActions from '../../../actions/coreActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './ServiceItemList.module.css';

const ToggleIcon = ({ on }) => (
    <span
        role="none"
        className={classes.toggleIcon}
    >
        {on ? <i className="fas fa-caret-down" /> : <i className="fas fa-caret-right" />}
    </span>
);
const pageSizes = [20, 50, 100];
const initialPageState = {
    skip:         0,
    take:         20,
    buttonCount:  5,
    type:         'input',
    info:         false,
    pageSizes:    pageSizes,
    previousNext: true,
    responsive:   true
};
  
const ServiceItemList = ({
    animationTarget,
    bobLoading,
    fetchAppointments,
    fetchServiceItemList,
    searchValue,
    setIsAnimated,
    setItemActive,
    setProgressBarLoading,
    serviceItemList,
    sortByFilter,
    totalItemCount,
    ...props
}) => {
    const [expandedState, setExpandedState] = useState([]);
    const [activeNode, setActiveNode] = useState({});
    const [pageState, setPageState] = useState(initialPageState);

    useEffect(() => {
        const expanded = [];

        serviceItemList.forEach((listItem, index) => {
            expanded[index] = true;
        });

        setExpandedState([...expanded]);
    }, [serviceItemList]);

    useEffect(() => {
        fetchServiceItemList({page: 1, pageSize: 20});
    }, [searchValue]);

    useEffect(() => {
        if (animationTarget) {
            setTimeout(() => {
                setIsAnimated(null);
            }, 2000);
        }
    }, [animationTarget]);

    const handlePageChange = event => {
        const {
            skip,
            take
        } = event;
        setPageState({ ...pageState,
            skip: skip,
            take: take
        });
        const page = skip / take + 1;
        fetchServiceItemList({page: page, pageSize: take});
    };

    const handleExpand = index => {
        const stateCopy = [...expandedState];
        stateCopy[index] = !stateCopy[index];

        setExpandedState(stateCopy);
    };

    const handleItemClick = async item => {
        setProgressBarLoading(true);
        setActiveNode(item);
        await setItemActive(item);
        await fetchAppointments(item.id);
        setProgressBarLoading(false);
    };

    const renderDate = date => {
        if (isEmpty(date)) return;

        const label = date.toLowerCase();

        if (label === 'today' || label === 'yesterday') return date;

        return format(date, 'MM-DD-YYYY');
    };

    const renderLastModifiedDateList = () => {
        return (
            serviceItemList.map((event, index) => {
                return (
                    <ServiceItemListItem
                        eventData={event}
                        key={index}
                        handleItemClick={() => handleItemClick(event)}
                        activeClass={event.id === activeNode.id ? classes.serviceItemActive : ''}
                        animatedClass={animationTarget && animationTarget === event.id ? classes.serviceItemAnimation : ''}
                        sortBy={sortByFilter}
                    />
                );
            })
        );
    };

    const renderCreationDateList = () => {
        return (
            serviceItemList.map((list, index) => {
                return (
                    <React.Fragment key={index}>
                        <li
                            className={classes.sectionHeader}
                            role="none"
                            onClick={() => handleExpand(index)}
                        >
                            <ToggleIcon
                                on={expandedState[index]}
                            />
                            <span>{renderDate(list.date)}</span>
                        </li>
                        {
                            expandedState[index] &&
                            <ul className={classes.subList}>
                                {
                                    list.events &&
                                    list.events.map((event, index) => {
                                        return (
                                            <ServiceItemListItem
                                                eventData={event}
                                                key={index}
                                                handleItemClick={() => handleItemClick(event)}
                                                activeClass={event.id === activeNode.id ? classes.serviceItemActive : ''}
                                                animatedClass={animationTarget && animationTarget === event.id ? classes.serviceItemAnimation : ''}
                                            />
                                        );
                                    })
                                }
                            </ul>
                        }
                    </React.Fragment>
                );
            })
        );
    };

    if (isEmpty(serviceItemList)) {
        return (
            <div className={classes.ServiceItemList}>
                {
                    bobLoading.includes('FetchServiceCallLists') ?
                        <BobLoadingMask /> 
                        : null
                }
                <div className={classes.emptyList}>
                    No Service Calls found.
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={classes.ServiceItemList}>
                {
                    bobLoading.includes('FetchServiceCallLists') ?
                        <BobLoadingMask /> 
                        : null
                }
                <ul className={classes.mainList}>
                    {
                        sortByFilter === 'insertTimestamp' ?
                            renderCreationDateList() :
                            renderLastModifiedDateList()
                    }
                </ul>
            </div>
            <div>
                <style>
                    {
                        `.k-pager-input .k-textbox {
                            font-size: 1.2rem;
                            color: black;
                        }
                        `
                    }
                </style>
                <Pager 
                    className={classes.KendoPager}
                    skip={pageState.skip}
                    take={pageState.take}
                    total={totalItemCount}
                    type={'input'}
                    onPageChange={handlePageChange}
                    // pageSizes={false}
                    info={pageState.info}
                    previousNext={pageState.previousNext}
                />
            </div>
        </React.Fragment>
    );
};

ServiceItemList.defaultProps = {
    searchValue:     '',
    serviceItemList: [],
    sortByFilter:    'insertTimestamp'
};

ServiceItemList.propTypes = {
    searchValue:     string,
    serviceItemList: array,
    sortByFilter:    string
};

const mapStateToProps = state => {
    return {
        animationTarget: state.svcManagement.animationTarget,
        bobLoading:      state.bob.bobLoading,
        searchValue:     state.svcManagement.searchValue,
        serviceItemList: state.svcManagement.serviceItemList.serviceItemList,
        sortByFilter:    state.svcManagement.sortByFilter,
        totalItemCount:  state.svcManagement.serviceItemList.meta.totalCount
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceItemList);
